import decoder from 'jwt-decode';
class AuthService {
    constructor(store) {
        this.store = store;
    }

    static authenticateUser(tokens) {
        this.setAccessToken(tokens.accessToken);
        this.setRefreshToken(tokens.refreshToken);
    }

    static isUserAuthenticated() {
        return localStorage.getItem('access_token') !== null;
    }

    static deauthenticateUser() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
    }

    static getAcessToken() {
        return localStorage.getItem('access_token');
    }

    static getRefreshToken() {
        return localStorage.getItem('refresh_token');
    }

    static getPayload(token = AuthService.getAcessToken()) {
        return decoder(token);
    }

    static getAuthToken() {
        return `Bearer ${localStorage.getItem('access_token')}`;
    }

    static isAdmin() {
        return (AuthService.getPayload()) ? AuthService.getPayload().Roles.includes('Administrator') : false;
    }

    static setRefreshToken(token) {
        localStorage.setItem('refresh_token', token);
    }

    static setAccessToken(token) {
        localStorage.setItem('access_token', token);
    }

    refresh() {
        return new Promise((resolve, reject) => {
            const UserId = this.constructor.getPayload().UserId;
            this.store.dispatch('refreshToken', {
                userId: UserId,
                refreshToken: this.constructor.getRefreshToken()
            }).then(() => resolve()).catch((error) => reject(error));
        });
    }

    logOut() {
        return new Promise((resolve, reject) => {
            this.store.dispatch('logOut');
            resolve();
        });
    }
}

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/AuthService.js